export default __webpack_public_path__ + "static/media/Raining.693ff9ee.svg";